import { NodeViewWrapper } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import { renderChemFormula } from './chem-formula-extension';

import type { ChemFormulaOptions } from './chem-formula-extension';
import type { NodeViewProps } from '@tiptap/core';

export function ChemFormulaView({ node, extension, updateAttributes }: NodeViewProps) {
  const { t } = useTranslation();
  const { onEditRequest } = (extension as unknown as { options: ChemFormulaOptions }).options;
  const { html, error } = renderChemFormula(String(node.attrs.formula));

  function handleEdit() {
    onEditRequest(String(node.attrs.formula), (newFormula) => updateAttributes({ formula: newFormula }));
  }

  return (
    <NodeViewWrapper
      as='span'
      className='chem-formula cursor-pointer'
      style={{ whiteSpace: 'nowrap' }}
      onDragStart={(e: React.DragEvent) => e.preventDefault()}
      onClick={handleEdit}
      // Had no accessible name at all, so the rendered glyph spans were all a screen reader got —
      // one character at a time. Named from the source, like the other two formula views.
      aria-label={`${String(node.attrs.formula ?? '')} — ${t('blocks.toolbar.chemFormulaLabel')}`}
    >
      <span style={{ display: 'block', overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap', paddingRight: '0.5em' }}>
        {html ? (
          <span data-authored='' dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <span className='text-xs' style={{ color: 'var(--color-ws-error-fg)' }}>
            {error ?? String(node.attrs.formula)}
          </span>
        )}
      </span>
    </NodeViewWrapper>
  );
}
